import { useState } from 'react';

export default (defaultUrl = null) => useState(defaultUrl);
